import React, { useEffect, useState } from "react";

function ConfirmDeleteAlert({ isOpen, projectName, onConfirm, onCancel }) {
  const [isVisible, setIsVisible] = useState(false);

  // Handle zoom-in/zoom-out animation
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1055,
      }}
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{
          transform: isVisible ? "scale(1)" : "scale(0.7)",
          opacity: isVisible ? 1 : 0,
          transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
        }}
      >
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title fw-bold">Confirm Deletion</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <p>
              Are you sure you want to delete the project{" "}
              <strong>{projectName}</strong>? This action cannot be undone.
            </p>
          </div>
          <div className="modal-footer border-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onConfirm}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteAlert;